import { FontSizes, FontWeights } from '@origin-digital/helper';
var LineHeights = {
  H1: 40,
  H2: 28,
  H3: 24,
  H4: 24,
  H5: 24,
  H6: 24,
  BODY: 24,
  SMALL: 20,
  Large: {
    H1: 64,
    H2: 40,
    H3: 28
  }
};
var Spacing = {
  M_Y_XXS: 8,
  M_Y_XS: 12,
  M_Y_SM: 16,
  M_Y: 24,
  M_Y_LG: 32,
  M_Y_XL: 40,
  M_Y_XXL: 64,
  M_Y_XXXL: 80,
  M_X_XS: 12,
  M_X_SM: 16,
  M_X: 24,
  M_X_LG: 32,
  M_X_XXS: 8,
  P_Y_XXS: 4,
  P_Y_XS: 8,
  P_Y_SM: 12,
  P_Y: 16,
  P_Y_LG: 24,
  P_Y_XL: 32,
  P_Y_XXL: 40,
  P_X_XS: 12,
  P_X_SM: 16,
  P_X: 24,
  P_X_LG: 32,
  P_X_XL: 40,
  P_X_XXL: 64,
  GUTTER: 30,
  GUTTER_SM: 15
};
var HeadingMargins = {
  H1: 48,
  H2: 24,
  H3: 16,
  H4: 16,
  Large: {
    H1: 64,
    H2: 32,
    H3: 24,
    H4: 24
  }
};
var ANIMATION = {
  CARD: {
    SCALE: 1.16,
    SPEED: '0.22s'
  },
  CHEVRON: {
    SPEED: '0.22s',
    TRANSLATE_MIN: '0px, -1px',
    TRANSLATE_MAX: '5px, -1px'
  }
};
export { FontSizes, FontWeights, LineHeights, Spacing, HeadingMargins, ANIMATION };